import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import { H3, H5, Image } from '../../../AbstractElements'
import { dynamicImage } from '../../../Utils'
import { Link } from 'react-router-dom'

export default function WeekendView() {
    return (
        <Col xxl={3} md={5} sm={6} className="box-col-5">
            <Card className="weekend-view">
                <CardBody>
                    <div className="inner-bg" />
                    <div className="img-wrapper">
                        <Image className="img-fluid" src={dynamicImage(`dashboard-2/headphone.png`)} alt="headphone" />
                    </div>
                    <div className="product-detail">
                        <H3>{'Special Weekend Offer'}</H3>
                        <H5>{'Upto 70% Off Discount'}</H5>
                        <Link className="btn" to={`${process.env.PUBLIC_URL}/ecommerce/product_list`}>{'View More'}</Link>
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}